import React from 'react';

export const ConfluenceLabsIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="11"
			height="10"
			viewBox="0 0 11 10"
			fill="none"
			data-testid="confluence-labs-icon"
		>
			<g clipPath="url(#clip0_1529_4199)">
				<path
					d="M10.2975 6.90435C7.00672 5.3913 6.04538 5.16522 4.65882 5.16522C3.03193 5.16522 1.64538 5.8087 0.406723 7.61739L0.203361 7.91304C0.0369748 8.15652 0 8.24348 0 8.34783C0 8.45217 0.0554622 8.53913 0.258824 8.66087L2.3479 9.89565C2.45882 9.96522 2.55126 10 2.6437 10C2.75462 10 2.82857 9.94783 2.9395 9.7913L3.27227 9.30435C3.78992 8.55652 4.2521 8.31304 4.8437 8.31304C5.36134 8.31304 5.97143 8.45217 6.72941 8.8L8.91092 9.77391C9.13277 9.87826 9.37311 9.82609 9.48403 9.58261L10.5193 7.42609C10.6303 7.18261 10.5563 7.02609 10.2975 6.90435ZM0.702521 3.09565C3.99328 4.6087 4.95462 4.83478 6.34118 4.83478C7.96807 4.83478 9.35462 4.1913 10.5933 2.38261L10.7966 2.08696C10.963 1.84348 11 1.75652 11 1.65217C11 1.54783 10.9445 1.46087 10.7412 1.33913L8.6521 0.104348C8.54118 0.0347826 8.44874 0 8.3563 0C8.24538 0 8.17143 0.0521739 8.0605 0.208696L7.72773 0.695652C7.21008 1.44348 6.7479 1.68696 6.1563 1.68696C5.63866 1.68696 5.02857 1.54783 4.27059 1.2L2.08908 0.226087C1.86723 0.121739 1.62689 0.173913 1.51597 0.417391L0.480672 2.57391C0.369748 2.81739 0.443698 2.97391 0.702521 3.09565Z"
					fill="#292A2E"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1529_4199">
					<rect width="11" height="10" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
